$(document).ready(function() {
    $("li.tertiary-menu-toggle").click(function() {
        $("nav.tertiary").toggleClass("hide-element");
        $(".header-primary").toggleClass("hide-element");
    });

    $(".hamburger-menu").click(function() {
        $("nav#mmenu").toggleClass("mm-menu mm-menu_offcanvas mm-menu_fullscreen mm-menu_position-top mm-menu_opened");
        $("html").toggleClass("mm-wrapper_opened mm-wrapper_blocking mm-wrapper_background mm-wrapper_opening");
    });

    $(".close").click(function() {
        $("nav#mmenu").removeClass("mm-menu mm-menu_offcanvas mm-menu_fullscreen mm-menu_position-top mm-menu_opened");
        $("html").removeClass("mm-wrapper_opened mm-wrapper_blocking mm-wrapper_background mm-wrapper_opening");
    });


    $(".accordion__title").click(function() {
        if ($(this).closest('.accordion').hasClass("is-active")) {
            $(".accordion").removeClass("is-active");
        }
        else {
            $(".accordion").removeClass("is-active");
            $(this).closest('.accordion').addClass("is-active");
        }
    });



    $('.key-figure').each(function () {
        var $this = $(this);
        jQuery({ Counter: 0 }).animate({ Counter: $this.attr('data-stop') }, {
            duration: 1000,
            easing: 'swing',
            step: function (now) {
                $this.text(Math.ceil(now)) + "%";
            }
        });
    });

    var lastScrollTop = 0;
    var scrollTopThreshold = 65;
    
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            // scrolling down
            $(".site-header").addClass("fixed");
            $(".header-primary .logo").removeClass("logo-big"); // remove "logo-big" class
            $(".header-primary .logo").addClass("logo-small"); // add "logo-small" class
        } else {
            // scrolling up
            if(scroll >= scrollTopThreshold) {
                $(".site-header").addClass("fixed");
                $(".header-primary .logo").addClass("logo-small");
                $(".header-primary .logo").removeClass("logo-big");
            } else {
                $(".site-header").removeClass("fixed");
                $(".header-primary .logo").removeClass("logo-small");
                $(".header-primary .logo").addClass("logo-big");
            }
        }
        lastScrollTop = st;
        
        // Add this block to remove the fixed class and scrolling-down class when at the top of the page
        if (scroll <= 0) {
            $(".header-primary .logo").removeClass("logo-small");
            $(".header-primary .logo").addClass("logo-big");
        }
    });

    $(".tertiary a.has-children").click(function() {
        var currentdataid = $(this).attr("data-id");
        $(".tertiary").find("ul[data-id='" + currentdataid + "']").addClass("is-active");
    });

    $(".world-map__marker").click(function() {
        var currentdataid = $(this).attr("data-id");
        $(".world-map__info").removeClass("world-map__info__active");
    
        // Add conditional statement to center the .world-map__info element on mobile displays
        if ($(window).width() < 700) {
            $(".world-map__info[data-id=" + currentdataid + "]")
                .addClass("world-map__info__active")
                .css({
                    "top": "50%",
                    "left": "50%",
                    "transform": "translate(-50%, -50%)"
                });
        } else {
            $(".world-map__info[data-id=" + currentdataid + "]").addClass("world-map__info__active");
        }
    });
    

    $(document).on('click', function (e) {
        if ($(e.target).closest(".world-map").length === 0) {
            $(".world-map__info").removeClass("world-map__info__active");
        }
    });

    $(window).scroll(function() {
        if ($(this).scrollTop()) {
            $('#toTop').fadeIn();
        } else {
            $('#toTop').fadeOut();
        }
    });

    $(window).scroll(function() {
        if ($(this).scrollTop()) {
            $('.back-to-top').fadeIn();
        } else {
            $('.back-to-top').fadeOut();
        }
    });

    $(".back-to-top").click(function() {
        $("html, body").animate({scrollTop: 0}, 1000);
    });

    $(".vcm-container .button").click(function() {
        var currentdataid = $(this).attr("data-id");
        $(".item-container[data-id=" + currentdataid + "]").toggleClass("hidden");
        $(".shadow[data-id=" + currentdataid + "]").toggleClass("hidden");

    });

    $(window).on('resize', function(){
        if ($(".vcm-container").width() < 1080) {
            console.log("succes");
            $(".vcm-container").addClass("mobile");
        }
        else {
            $(".vcm-container").removeClass("mobile");
        }
    });
});

// Tertiary menu toggle
document.addEventListener("DOMContentLoaded", function(event) {
    const element = document.querySelector('.tertiary-menu-toggle a');

    element.addEventListener('click', function(event) {
        event.preventDefault();

        const linkText = this.textContent;
        const copyText = this.getAttribute('data-copy');

        this.textContent = copyText;
        this.setAttribute('data-copy', linkText);
    });
});